module.exports = __webpack_public_path__ + "img/hotel1.b847678a.png";